import { forwardRef, Icon, IconProps } from '@chakra-ui/react'
import { BiMinus, BiPlus } from 'react-icons/bi'

export const MinusIcon = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiMinus} />
))
export const PlusIcon = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiPlus} />
))
